<template>
  <div class="mb-2" v-if="is_displayed">
    <div class="text-h6 mb-2">Donation</div>
    <div class="mb-1 font-weight-bold">
      Faire un don à {{ donation.beneficiaire }}
      <a v-if="donation.url_beneficiaire" :href="donation.url_beneficiaire" target="_blank">
        <v-btn variant="text" color="primary-dark" density="compact" size="small"><v-icon icon="mdi-information-outline"
            class="mr-1" size="large"></v-icon> Plus d'informations</v-btn>
      </a>
    </div>



    <div class="mb-2">
      <v-btn-toggle color="primary-dark" density="compact" size="small" divided variant="outlined"
        v-model="montant_selectionne">
        <v-btn color="primary-dark" :value="proposition.value" v-for="(proposition, index) in montants_proposes"
          :key="index">
          {{ proposition.text }}
        </v-btn>
      </v-btn-toggle>
    </div>


    <div class="mt-2" v-if="montant_selectionne == -1">
      <v-row>
        <v-col cols="12" md="3">
          <v-text-field class="shrink" v-model="donation.montant" label="Montant de votre don libre" type="number"
            suffix="€" outlined dense></v-text-field>
        </v-col>
      </v-row>
    </div>
    <div v-if="donation.description != ''" v-html="donation.description"></div>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
export default {
  props: ["item"],
  data() {
    return {
      montant_selectionne: 0,
      montants_proposes: [],
      donation: {},
    };
  },
  watch: {
    "donation.montant": function () {
      this.$emit("changeDonation");
    },
    montant_selectionne: function (val) {
      if (val == -1) {
        return;
      } else {
        this.donation.montant = val;
      }
    },
  },
  computed: {
    ...mapStores(useMainStore),
    is_displayed() {
      if (this.donation.actif == 0) {
        return false;
      }
      const donation_empreinte_carbone = this.mainStore.module.donation_empreinte_carbone;
      if (donation_empreinte_carbone) {
        return this.donation.montant > 0;
      }
      return true;
    },

  },
  created() {
    this.donation = this.item;
    this.montant_selectionne = this.donation.get_montant_selectionne();
    this.montants_proposes = this.donation.get_montants_proposes();




  },
};
</script>

<style lang="scss" scoped></style>